import { PropsWithChildren } from 'react';
import { RemixiconReactIconComponentType } from 'remixicon-react';
import Cosmetic from './cosmetic';
import MainContent from './maincontent';

export type PopupModalTheme = 'primary' | 'success' | 'danger' | 'warning';

export type PopupModalProps = {
  theme?: PopupModalTheme;
  title?: string;
  description?: string;
  onClose?: () => void;
  allowClose?: boolean;
  headerSide?: 'left' | 'top';
  titleSize?: 'md' | 'lg';
  width?: number;
  overrideIcon?: RemixiconReactIconComponentType | string;
};

const titleColorMap: {
  [key in PopupModalTheme]: string;
} = {
  primary: 'primary',
  danger: 'red-800',
  warning: 'yellow-900',
  success: 'green-800',
};

export const PopupModal = ({
  theme = 'primary',
  headerSide = 'left',
  titleSize = 'md',
  width = 400,
  ...props
}: PropsWithChildren<PopupModalProps>) => {
  const title = props.title;
  const description = props.description;
  const onClose = props.onClose;
  const titleColor = titleColorMap[theme];
  return (
    <>
      <div
        className={`flex h-full w-full md:w-auto ${headerSide === 'left' ? 'flex-row' : 'flex-col'}  rounded-lg`}
        style={{
          maxWidth: headerSide === 'left' ? width + 'px' : 'auto',
        }}
      >
        <Cosmetic theme={theme} headerSide={headerSide} overrideIcon={props.overrideIcon} />
        <MainContent
          theme={theme}
          title={title}
          description={description}
          titleSize={titleSize}
          onClose={onClose}
          titleColor={titleColor}
          allowClose={props.allowClose}
        >
          {props.children}
        </MainContent>
      </div>
      {/* <BackDrop /> */}
    </>
  );
  // document.body,
  // );
};

// export const PopupModal = Object.assign(BaseModal, {
//   ButtonPanel: ButtonPanel,
// });
